import styled from 'styled-components';

const OptionsStepContainer = styled.div``;

export default OptionsStepContainer;
